import { useEffect, useRef, useState } from "react";

const metrics = [
  { value: 20, suffix: "+", label: "Automatizaciones implementadas" },
  { value: 300, suffix: "%", label: "Mejora en tiempos de respuesta" },
  { value: 40, suffix: "%", label: "Incremento potencial de conversión" },
  { value: 24, suffix: "/7", label: "Atención sin pausas, todo el año" },
];

function useCountUp(target, duration = 1600, start) {
  const [val, setVal] = useState(0);
  const startedRef = useRef(false);
  useEffect(() => {
    if (!start || startedRef.current) return;
    startedRef.current = true;
    const t0 = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(target * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => raf && cancelAnimationFrame(raf);
  }, [start, target, duration]);
  return val;
}

function MetricCard({ m, start, idx }) {
  const v = useCountUp(m.value, 1500 + idx * 150, start);
  return (
    <div className="reveal grad-border p-7 card-lift">
      <div className="font-display font-extrabold text-5xl sm:text-6xl text-gradient text-glow tracking-tighter">
        {v}
        <span className="text-white/90">{m.suffix}</span>
      </div>
      <div className="mt-3 text-zinc-400 text-sm leading-relaxed max-w-[18ch]">{m.label}</div>
    </div>
  );
}

export default function Metrics() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const io = new IntersectionObserver(
      (e) => e.forEach((x) => x.isIntersecting && setVisible(true)),
      { threshold: 0.3 }
    );
    if (ref.current) io.observe(ref.current);
    return () => io.disconnect();
  }, []);

  return (
    <section id="metrics" data-testid="metrics-section" className="relative py-24 sm:py-32">
      <div className="container-x">
        <div className="max-w-2xl reveal">
          <div className="eyebrow mb-5">Resultados</div>
          <h2 className="font-display font-extrabold text-white text-4xl sm:text-5xl tracking-tighter leading-[1.05]">
            Números reales, <span className="text-gradient">no slides bonitos</span>.
          </h2>
        </div>
        <div ref={ref} className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {metrics.map((m, i) => (
            <MetricCard key={m.label} m={m} start={visible} idx={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
